// Decide the buyer's billing region on the client.
// India → INR + Razorpay (PayPal isn't available to Indian buyers).
// Everyone else → USD + PayPal.
// Best-effort: uses timezone (strongest signal) then locale. No network call.
export function isIndia() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (tz === 'Asia/Kolkata' || tz === 'Asia/Calcutta') return true;
  } catch (_) {}
  try {
    const langs = [navigator.language, ...(navigator.languages || [])].filter(Boolean);
    if (langs.some((l) => /-IN$/i.test(l))) return true;
  } catch (_) {}
  return false;
}

// Returns 'IN' or 'INTL'.
export function billingRegion() {
  return isIndia() ? 'IN' : 'INTL';
}
